import { useEffect } from 'react'

import { stripeAPI } from '../../api/services/stripe'

const CheckStripeRequirements = ({
  setIsRequirementFilled
}: {
  setIsRequirementFilled: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  useEffect(() => {
    ( async () => {
      try {
        const requirementsResponse = await stripeAPI.requirements_filled()
        if (requirementsResponse.status === 200) {
          setIsRequirementFilled(requirementsResponse.data.requirements_filled)
        }
      } catch (error) {
        console.log('required error: ', error)
      }
    })()
  }, [])

  return null
}

export default CheckStripeRequirements
